import { MenuItem } from '@mui/material';
import { StyledSelect } from 'components/commons/StyledSelect';
import Colors from 'constants/colors';

const M2 = 'm²';
const HA = 'ha';
const AreaUnit = function(props) {
    const changed = props.value && props.value !== M2;
    return (
        <StyledSelect
            value={props.value || M2}
            changed={changed}
            onChange={props.onChange}
            variant="outlined"
            MenuProps={{ keepMounted: true, disablePortal: true }}
            height={props.height}
            textColor={props.textColor}
            borderColor={props.borderColor}
        >
            <MenuItem value={M2}>{M2}</MenuItem>
            <MenuItem value={HA}>{HA}</MenuItem>
        </StyledSelect>
    );
};

AreaUnit.defaultProps = {
    height: '38px',
    borderColor: Colors.BLACK_30_OPAQUE,
    textColor: Colors.BLACK_60_OPAQUE,
};

export default AreaUnit;